// pp-customer-empresa.js — puebla la página "Mi Empresa" (B2B Fases 1+2+3).
//
// Empresa/ejecutivo: /apps/crm/customer-company (o el cache de sesión que dejó
// pp-company.js). Miembros: /apps/crm/customer-members SIN cache (cambia al
// invitar / cambiar rol / quitar). Las acciones de gestión (invitar, cambiar rol,
// quitar, renombrar empresa) solo se muestran si el backend dice can_manage
// (Admin); el enforcement real vive en el backend. Sin empresa → estado vacío.

(function () {
  'use strict';

  var root = document.querySelector('[data-pp-company-root]');
  if (!root) return;
  var empty = root.querySelector('[data-pp-company-empty]');
  var body = root.querySelector('[data-pp-company-body]');
  var bodySkeleton = root.querySelector('[data-pp-company-body-skeleton]');
  var list = root.querySelector('[data-pp-members-list]');
  var membersChip = root.querySelector('[data-pp-co-members-chip]');
  var inviteToggle = root.querySelector('[data-pp-invite-toggle]');
  var inviteForm = root.querySelector('[data-pp-invite-form]');
  var feedback = root.querySelector('[data-pp-invite-feedback]');
  var teamLargeNote = root.querySelector('[data-pp-team-large]');
  var dataEditBtn = root.querySelector('[data-pp-company-data-edit]');
  var dataForm = root.querySelector('[data-pp-company-data-form]');
  var dataView = root.querySelector('[data-pp-company-data-view]');
  var dataFeedback = root.querySelector('[data-pp-company-data-feedback]');
  var dataCancelBtn = root.querySelector('[data-pp-company-data-cancel]');
  var activityCard = root.querySelector('[data-pp-company-activity]');
  var activitySkeleton = root.querySelector('[data-pp-activity-skeleton]');
  var activityList = root.querySelector('[data-pp-activity-list]');
  var activityEmpty = root.querySelector('[data-pp-activity-empty]');
  var activityFilters = root.querySelector('[data-pp-activity-filters]');

  // Filtro de actividad por categoría. Los items se guardan en memoria al
  // renderizar para re-filtrar sin re-fetch. Orden fijo para los pills.
  var ACTIVITY_CATEGORIES = ['actualizaciones', 'compras', 'facturacion', 'demas'];
  var activityItems = [];
  var activityFilter = 'all';

  // Estado de gestión (lo dicta el backend). Por default, sin poderes.
  var canManage = false;
  // La empresa tiene línea de crédito activa (backend). El toggle "Puede usar
  // crédito" solo se muestra si es true — sin crédito no aplica.
  var hasCredit = false;
  var companyName = '';

  var ROLES = ['admin', 'comprador', 'finanzas'];
  // Campos de empresa editables por el admin (mismos que update_company del backend).
  var COMPANY_FIELDS = ['nombre_comercial', 'phone', 'whatsapp', 'website', 'giro', 'num_employees'];
  var companyData = {}; // últimos valores conocidos, para prellenar el form
  var giroOptions = []; // opciones de "Giro o Actividad" que manda el backend (customer-company.giros)

  function t(name) { return root.getAttribute('data-t-' + name) || ''; }

  function set(sel, text) {
    var el = root.querySelector(sel);
    if (el) el.textContent = text || '';
  }

  function roleLabel(role) { return t('role-' + role) || role; }

  // Iniciales para el avatar: primeras letras de las dos primeras palabras.
  function initials(name) {
    var words = String(name || '').trim().split(/\s+/).filter(Boolean);
    var out = words.slice(0, 2).map(function (w) { return w.charAt(0); }).join('');
    return out.toUpperCase() || '?';
  }

  function renderCompany(d) {
    // La resolución (found o no) ya llegó → retirar el skeleton del cuerpo.
    if (bodySkeleton) bodySkeleton.hidden = true;
    if (!d || !d.found || !d.company || !d.company.name) {
      if (empty) empty.hidden = false;
      if (body) body.hidden = true;
      return false;
    }
    if (empty) empty.hidden = true;
    if (body) body.hidden = false;

    companyName = d.company.name;
    set('[data-pp-company-name]', d.company.name);
    set('[data-pp-co-avatar]', initials(d.company.name));
    renderCompanyData(d);

    var mgr = root.querySelector('[data-pp-company-manager]');
    if (d.account_manager && d.account_manager.name) {
      set('[data-pp-company-manager-name]', d.account_manager.name);
      set('[data-pp-mgr-avatar]', initials(d.account_manager.name));
      set('[data-pp-mgr-sub]', t('manager-sub').replace('{company}', d.company.name));
      var wa = root.querySelector('[data-pp-company-wa]');
      if (wa && d.account_manager.whatsapp) {
        wa.href = 'https://wa.me/' + String(d.account_manager.whatsapp).replace(/\D/g, '');
        wa.hidden = false;
      }
    } else if (mgr) {
      mgr.hidden = true;
    }
    return true;
  }

  // ── Datos de la empresa (display; edición solo Admin más abajo) ──

  function setCF(field, value) {
    var el = root.querySelector('[data-pp-cf-' + field + ']');
    if (el) el.textContent = (value == null || value === '') ? '—' : String(value);
  }

  function renderCompanyData(d) {
    var c = (d && d.company) || {};
    if (d && Array.isArray(d.giros)) giroOptions = d.giros;
    COMPANY_FIELDS.forEach(function (f) {
      companyData[f] = (c[f] == null ? '' : c[f]);
      setCF(f, c[f]);
    });
  }

  // ── Miembros ──

  function memberRow(m) {
    var li = document.createElement('li');
    li.className = 'pp-empresa__member';
    if (m.revoked) li.classList.add('pp-empresa__member--inactive');
    if (m.contact_id) li.setAttribute('data-contact-id', m.contact_id);

    var avatar = document.createElement('span');
    avatar.className = 'pp-empresa__member-avatar';
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = initials(m.name || m.email);

    var info = document.createElement('span');
    info.className = 'pp-empresa__member-info';
    info.textContent = m.name || '';
    if (m.email) {
      var mail = document.createElement('span');
      mail.className = 'pp-empresa__member-email';
      mail.textContent = (m.name ? ' (' : '(') + m.email + ')';
      info.appendChild(mail);
    }

    li.appendChild(avatar);
    li.appendChild(info);

    // Estatus (Tú / Invitación Enviada / Sin Cuenta Web).
    var chipText = '', chipMod = '';
    if (m.is_you) { chipText = t('chip-you'); chipMod = 'you'; }
    else if (m.status === 'invited') { chipText = t('chip-invited'); chipMod = 'invited'; }
    else if (m.status === 'contact') { chipText = t('chip-no-account'); }
    if (chipText) {
      var chip = document.createElement('span');
      chip.className = 'pp-empresa__member-chip' + (chipMod ? ' pp-empresa__member-chip--' + chipMod : '');
      chip.textContent = chipText;
      li.appendChild(chip);
    }
    if (m.revoked) {
      var inactiveChip = document.createElement('span');
      inactiveChip.className = 'pp-empresa__member-chip pp-empresa__member-chip--inactive';
      inactiveChip.textContent = t('inactive');
      li.appendChild(inactiveChip);
    }

    // Controles: agrupados para que en móvil bajen juntos a su propia línea
    // (ver .pp-empresa__member-controls en el CSS).
    var controls = document.createElement('span');
    controls.className = 'pp-empresa__member-controls';

    // Crédito (Task 5b): solo Admin, y solo si el miembro sigue activo (un
    // miembro revocado no puede comprar de ningún modo, con o sin crédito).
    // El backend (Task 5a) valida can_manage de nuevo en el POST; aquí solo
    // controlamos si SE MUESTRA el control.
    if (canManage && hasCredit && m.contact_id && !m.revoked) {
      controls.appendChild(creditToggle(m));
    }

    // Rol: selector/desactivar si estoy activo; etiqueta+activar si está inactivo;
    // solo etiqueta si no puedo gestionar. Nunca al principal ni a mí mismo.
    var canAct = canManage && !m.is_principal && !m.is_you && m.contact_id;
    if (canAct && !m.revoked) {
      controls.appendChild(roleSelect(m));
      controls.appendChild(deactivateButton(m));
    } else if (canAct && m.revoked) {
      var roleTag = document.createElement('span');
      roleTag.className = 'pp-empresa__role-tag';
      roleTag.textContent = roleLabel(m.role);
      controls.appendChild(roleTag);
      controls.appendChild(activateButton(m));
    } else {
      var roleTag2 = document.createElement('span');
      roleTag2.className = 'pp-empresa__role-tag';
      roleTag2.textContent = roleLabel(m.role);
      controls.appendChild(roleTag2);
    }
    li.appendChild(controls);
    return li;
  }

  // Switch "Puede usar crédito" — Admin activa/desactiva que este miembro
  // pague con la línea de crédito de la empresa en el checkout. Estado inicial
  // = m.puede_usar_credito del GET; el cambio es optimista (ver setMemberCredit).
  function creditToggle(m) {
    var wrap = document.createElement('span');
    wrap.className = 'pp-empresa__credit';

    var labelWrap = document.createElement('span');
    labelWrap.className = 'pp-empresa__credit-label-wrap';

    var labelText = document.createElement('span');
    labelText.className = 'pp-empresa__credit-label';
    labelText.textContent = t('credit-label') || 'Puede Usar Crédito';
    labelWrap.appendChild(labelText);

    var tip = t('credit-tooltip');
    if (tip) {
      var info = document.createElement('span');
      info.className = 'pp-empresa__credit-info';
      info.setAttribute('tabindex', '0');
      info.setAttribute('role', 'img');
      info.setAttribute('aria-label', tip);
      info.title = tip;
      info.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
      labelWrap.appendChild(info);
    }

    wrap.appendChild(labelWrap);

    var switchLabel = document.createElement('label');
    switchLabel.className = 'pp-empresa__switch';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'pp-empresa__switch-input';
    input.checked = !!m.puede_usar_credito;
    input.setAttribute('aria-label', (t('credit-label') || 'Puede Usar Crédito') + (m.name || m.email ? ' — ' + (m.name || m.email) : ''));

    var track = document.createElement('span');
    track.className = 'pp-empresa__switch-track';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'pp-empresa__switch-thumb';
    track.appendChild(thumb);

    switchLabel.appendChild(input);
    switchLabel.appendChild(track);
    wrap.appendChild(switchLabel);

    input.addEventListener('change', function () {
      setMemberCredit(m.contact_id, input.checked, input);
    });

    return wrap;
  }

  function creditErr(code) {
    if (code === 'forbidden') return t('err-forbidden') || t('credit-error') || t('err-generic');
    return t('credit-error') || t('err-generic');
  }

  // Optimista: el switch ya cambió visualmente al disparar 'change'. Si el POST
  // falla (red o backend), se revierte al valor anterior y se avisa en la
  // misma franja de feedback que usan invitar/rol/desactivar (sin window.alert).
  function setMemberCredit(contactId, value, input) {
    input.disabled = true;
    post('set_credit_permission', { contact_id: contactId, value: value })
      .then(function (res) {
        if (res.d && res.d.ok) {
          showFeedback(t('credit-updated') || 'Permiso de crédito actualizado.', false);
        } else {
          input.checked = !value; // revertir
          showFeedback(creditErr(res.d && res.d.code), true);
        }
      })
      .catch(function () {
        input.checked = !value; // revertir
        showFeedback(creditErr(null), true);
      })
      .finally(function () { input.disabled = false; });
  }

  function roleSelect(m) {
    var sel = document.createElement('select');
    sel.className = 'pp-empresa__role-select';
    sel.setAttribute('aria-label', t('role-aria') || 'Rol');
    ROLES.forEach(function (r) {
      var opt = document.createElement('option');
      opt.value = r;
      opt.textContent = roleLabel(r);
      if (r === m.role) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener('change', function () {
      changeRole(m.contact_id, sel.value, sel);
    });
    return sel;
  }

  function deactivateButton(m) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-empresa__remove-btn';
    btn.setAttribute('aria-label', (t('deactivate') || 'Desactivar') + ' ' + (m.name || ''));
    btn.title = t('deactivate') || 'Desactivar';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';
    btn.addEventListener('click', function () {
      var msg = (t('deactivate-confirm') || '¿Desactivar a {name}?').replace('{name}', m.name || m.email || '');
      if (!window.confirm(msg)) return;
      setMemberActive(m.contact_id, false, btn);
    });
    return btn;
  }

  function activateButton(m) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-empresa__activate-btn';
    btn.textContent = t('activate') || 'Activar';
    btn.setAttribute('aria-label', (t('activate') || 'Activar') + ' ' + (m.name || ''));
    btn.addEventListener('click', function () {
      setMemberActive(m.contact_id, true, btn);
    });
    return btn;
  }

  function post(action, payload) {
    return fetch('/apps/crm/customer-members', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ action: action }, payload))
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (d) { return { status: r.status, d: d }; });
    });
  }

  function changeRole(contactId, role, sel) {
    var prev = sel.getAttribute('data-prev') || sel.value;
    sel.disabled = true;
    post('set_role', { contact_id: contactId, role: role })
      .then(function (res) {
        if (res.d && res.d.ok) {
          sel.setAttribute('data-prev', role);
          showFeedback((t('role-updated') || 'Rol actualizado.'), false);
        } else {
          sel.value = prev; // revertir en UI
          showFeedback(mapErr(res.d && res.d.code), true);
        }
      })
      .catch(function () { sel.value = prev; showFeedback(t('err-generic'), true); })
      .finally(function () { sel.disabled = false; });
  }

  // Activa/desactiva un miembro (SOFT en el backend). A diferencia del remove
  // legacy, NO borra la fila: se recarga la lista completa para que el estado
  // (chip Inactivo, botón Activar/Desactivar) refleje lo que diga el backend.
  function setMemberActive(contactId, active, btn) {
    btn.disabled = true;
    post(active ? 'reactivate' : 'deactivate', { contact_id: contactId })
      .then(function (res) {
        if (res.d && res.d.ok) {
          reloadMembers();
          showFeedback(t(active ? 'member-activated' : 'member-deactivated'), false);
        } else {
          showFeedback(mapErr(res.d && res.d.code), true);
        }
      })
      .catch(function () { showFeedback(t('err-generic'), true); })
      .finally(function () { btn.disabled = false; });
  }

  function mapErr(code) {
    if (code === 'principal_locked') return t('err-principal-locked') || t('err-generic');
    if (code === 'forbidden') return t('err-forbidden') || t('err-generic');
    if (code === 'cannot_remove_self') return t('err-remove-self') || t('err-generic');
    if (code === 'last_admin') return t('err-last-admin') || t('err-generic');
    if (code === 'member_revoked') return t('err-member-revoked') || t('err-generic');
    return t('err-generic');
  }

  function updateMembersChip(count) {
    if (!membersChip) return;
    membersChip.textContent = count === 1 ? t('member-one') : t('member-many').replace('{count}', String(count));
    membersChip.hidden = false;
  }

  function renderMembers(d) {
    if (!d || !d.found || !list) return;
    canManage = !!d.can_manage;
    hasCredit = !!d.has_credit;
    list.textContent = '';
    var members = d.members || [];
    members.forEach(function (m) { list.appendChild(memberRow(m)); });
    updateMembersChip(members.length);
    if (d.team_too_large) {
      if (teamLargeNote) { teamLargeNote.textContent = t('team-large'); teamLargeNote.hidden = false; }
      if (membersChip) membersChip.hidden = true;
      return; // bolsón genérico: sin gestión
    }
    if (canManage) {
      if (inviteToggle) inviteToggle.hidden = false;
      setupCompanyRename();
      setupCompanyDataEdit();
    }
  }

  // ── Actividad de tu equipo ──
  // GET /apps/crm/customer-activity: { found, items:[{ when, actor_name, action, summary }] }.
  // Sin empresa → found:false. Revoked → 403. En cualquier caso de error se
  // esconde la card con gracia (no es contenido crítico de la página).

  function hideActivityCard() {
    if (activityCard) activityCard.hidden = true;
  }

  // Tiempo relativo simple: min → h → "ayer" → días. Más allá de una semana,
  // cae a fecha corta ("12 jul") en vez de seguir contando días.
  function relativeTime(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var diffSec = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diffSec < 60) return t('activity-time-now');
    var diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return (t('activity-time-minutes') || '').replace('{n}', String(diffMin));
    var diffHour = Math.floor(diffMin / 60);
    if (diffHour < 24) return (t('activity-time-hours') || '').replace('{n}', String(diffHour));
    var diffDay = Math.floor(diffHour / 24);
    if (diffDay === 1) return t('activity-time-yesterday');
    if (diffDay < 7) return (t('activity-time-days') || '').replace('{n}', String(diffDay));
    try { return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' }); } catch (_) { return ''; }
  }

  function activityRow(item) {
    var li = document.createElement('li');
    li.className = 'pp-empresa__member pp-empresa__activity-item';

    var avatar = document.createElement('span');
    avatar.className = 'pp-empresa__member-avatar';
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = initials(item.actor_name);

    var info = document.createElement('span');
    info.className = 'pp-empresa__activity-info';

    var text = document.createElement('span');
    text.className = 'pp-empresa__activity-text';
    var strong = document.createElement('strong');
    strong.textContent = item.actor_name || '';
    text.appendChild(strong);
    if (item.summary) text.appendChild(document.createTextNode(' ' + item.summary));

    var time = document.createElement('span');
    time.className = 'pp-empresa__activity-time';
    time.textContent = relativeTime(item.when);

    info.appendChild(text);
    info.appendChild(time);
    li.appendChild(avatar);
    li.appendChild(info);
    return li;
  }

  // Categoría normalizada de un item. Degrada con gracia: si el backend aún no
  // manda `category` (o manda un valor desconocido), cae a 'demas' — nunca truena.
  function activityCategory(item) {
    var c = item && item.category;
    return ACTIVITY_CATEGORIES.indexOf(c) === -1 ? 'demas' : c;
  }

  function activityFilterChip(value, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-empresa__activity-chip';
    btn.textContent = label;
    btn.setAttribute('data-filter', value);
    var active = value === activityFilter;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.addEventListener('click', function () { applyActivityFilter(value); });
    return btn;
  }

  // Construye los pills SOLO con las categorías presentes (+ "Todas" siempre).
  // Con ≤1 categoría (p.ej. el backend aún no manda `category` → todo cae a
  // 'demas') no vale la pena filtrar: se ocultan los pills y se lista todo.
  function buildActivityFilters(items) {
    if (!activityFilters) return;
    activityFilter = 'all';
    var present = {};
    items.forEach(function (it) { present[activityCategory(it)] = true; });
    var cats = ACTIVITY_CATEGORIES.filter(function (c) { return present[c]; });

    activityFilters.textContent = '';
    if (cats.length <= 1) { activityFilters.hidden = true; return; }

    activityFilters.appendChild(activityFilterChip('all', t('activity-filter-all') || 'Todas'));
    cats.forEach(function (c) {
      activityFilters.appendChild(activityFilterChip(c, t('activity-filter-' + c) || c));
    });
    activityFilters.hidden = false;
  }

  function applyActivityFilter(value) {
    activityFilter = value;
    if (activityFilters) {
      Array.prototype.forEach.call(activityFilters.querySelectorAll('[data-filter]'), function (btn) {
        var on = btn.getAttribute('data-filter') === value;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    renderActivityList();
  }

  // Pinta la lista según el filtro activo. Si el filtro deja la lista vacía,
  // muestra un mini empty-state (reusa el <p> de vacío con otro texto).
  function renderActivityList() {
    if (!activityList) return;
    var visible = activityItems.filter(function (it) {
      return activityFilter === 'all' || activityCategory(it) === activityFilter;
    });
    activityList.textContent = '';
    if (!visible.length) {
      activityList.hidden = true;
      if (activityEmpty) {
        activityEmpty.textContent = t('activity-filter-empty') || '';
        activityEmpty.hidden = false;
      }
      return;
    }
    visible.forEach(function (item) { activityList.appendChild(activityRow(item)); });
    activityList.hidden = false;
    if (activityEmpty) activityEmpty.hidden = true;
  }

  function renderActivity(d) {
    if (!activityCard) return;
    if (!d || !d.found) { hideActivityCard(); return; }

    if (activitySkeleton) activitySkeleton.hidden = true;

    var items = Array.isArray(d.items) ? d.items : [];
    activityItems = items;
    if (!items.length) {
      if (activityEmpty) activityEmpty.hidden = false;
      if (activityList) activityList.hidden = true;
      if (activityFilters) activityFilters.hidden = true;
      return;
    }

    buildActivityFilters(items);
    applyActivityFilter('all');
  }

  function loadActivity() {
    if (!activityCard) return;
    fetch('/apps/crm/customer-activity', { method: 'GET', credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 403) return null; // acceso revocado → esconder con gracia
        return r.json().catch(function () { return null; });
      })
      .then(renderActivity)
      .catch(hideActivityCard);
  }

  // ── Renombrar empresa (solo Admin) ──

  function setupCompanyRename() {
    var host = root.querySelector('[data-pp-company-name]');
    if (!host || host.querySelector('.pp-empresa__name-edit')) return; // ya montado
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-empresa__name-edit';
    btn.title = t('edit-company') || 'Editar nombre';
    btn.setAttribute('aria-label', t('edit-company') || 'Editar nombre');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
    btn.addEventListener('click', function () {
      var next = window.prompt(t('edit-company-prompt') || 'Nuevo nombre de la empresa:', companyName);
      if (next == null) return;
      next = next.trim();
      if (!next || next === companyName) return;
      btn.disabled = true;
      post('rename_company', { name: next })
        .then(function (res) {
          if (res.d && res.d.ok) {
            companyName = res.d.name || next;
            set('[data-pp-company-name]', companyName);
            host.appendChild(btn); // re-montar (set() borró el innerHTML)
            set('[data-pp-co-avatar]', initials(companyName));
            // Mantener el cache fresco (si no, el refresh pinta el nombre viejo).
            var cc = ppReadCache();
            if (cc && cc.company) { cc.company.name = companyName; ppWriteCache(cc); }
            showFeedback((t('company-renamed') || 'Nombre actualizado.'), false);
          } else {
            showFeedback((res.d && res.d.code === 'invalid_name') ? (t('err-invalid') || '') : mapErr(res.d && res.d.code), true);
          }
        })
        .catch(function () { showFeedback(t('err-generic'), true); })
        .finally(function () { btn.disabled = false; });
    });
    host.appendChild(btn);
  }

  // ── Datos de la empresa: editar (solo Admin) ──

  function showDataFeedback(msg, isError) {
    if (!dataFeedback) return;
    dataFeedback.textContent = msg || '';
    dataFeedback.classList.toggle('pp-empresa__feedback--error', !!isError);
    dataFeedback.hidden = false;
  }

  function dataErr(code) {
    if (code === 'forbidden') return t('err-forbidden') || t('err-generic');
    if (code === 'too_long') return t('err-too-long') || t('err-generic');
    if (code === 'invalid_num_employees') return t('err-num-employees') || t('err-generic');
    if (code === 'invalid_name') return t('err-invalid') || t('err-generic');
    return t('err-generic');
  }

  function fillDataForm() {
    if (!dataForm) return;
    COMPANY_FIELDS.forEach(function (f) {
      var input = dataForm.querySelector('[name="' + f + '"]');
      if (!input || input.tagName === 'SELECT') return; // select: opciones dinámicas, ver buildGiroSelect
      input.value = (companyData[f] == null ? '' : companyData[f]);
    });
    buildGiroSelect();
  }

  // Puebla el <select name="giro"> con las opciones que manda el backend
  // (customer-company.giros, mismas ~72 del CRM). Legacy handling: si el valor
  // guardado ya no está en la lista (dato viejo), se agrega como opción extra al
  // inicio, seleccionada, marcada "(anterior)" — mismo espíritu que
  // GiroComercialSelect del CRM (apps/crm/src/shared/components/GiroComercialSelect.tsx).
  function buildGiroSelect() {
    var select = dataForm.querySelector('[name="giro"]');
    if (!select) return;
    var current = companyData.giro || '';
    var isLegacy = !!current && giroOptions.indexOf(current) === -1;

    select.textContent = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = t('giro-placeholder') || 'Seleccionar giro…';
    if (!current) placeholder.selected = true;
    select.appendChild(placeholder);

    if (isLegacy) {
      var legacyOpt = document.createElement('option');
      legacyOpt.value = current;
      legacyOpt.textContent = current + ' ' + (t('giro-legacy') || '(anterior)');
      legacyOpt.selected = true;
      select.appendChild(legacyOpt);
    }

    giroOptions.forEach(function (g) {
      var opt = document.createElement('option');
      opt.value = g;
      opt.textContent = g;
      if (!isLegacy && g === current) opt.selected = true;
      select.appendChild(opt);
    });
  }

  function closeDataForm() {
    if (dataForm) dataForm.hidden = true;
    if (dataView) dataView.hidden = false;
    if (dataEditBtn) dataEditBtn.hidden = false;
  }

  // ── Cache de sessionStorage (misma key que pp-company.js) ──
  // Mantenerlo en sync tras editar es CRÍTICO: si queda viejo, (a) un refresh
  // pinta datos viejos y (b) el form de edición pre-carga valores viejos que al
  // guardar borran campos (p.ej. se borró el WhatsApp). Ver pp-company.js.
  function ppCacheKey() {
    var rail = document.querySelector('[data-pp-customer]');
    // v5 (7-oct-2026): teléfono del ejecutivo SÓLO corporativo. Ni v3 ni v4 (v4
    // era la llave de pp-company.js y pudo guardar el número personal).
    return 'pp_company_v5:' + ((rail && rail.getAttribute('data-pp-customer')) || 'anon');
  }
  function ppReadCache() {
    try { return JSON.parse(sessionStorage.getItem(ppCacheKey()) || 'null'); } catch (_) { return null; }
  }
  function ppWriteCache(d) {
    try { sessionStorage.setItem(ppCacheKey(), JSON.stringify(d)); } catch (_) {}
  }
  // Fusiona los campos de empresa recién guardados en el cache.
  function ppPatchCacheCompany(fields) {
    var c = ppReadCache();
    if (c && c.company) {
      COMPANY_FIELDS.forEach(function (f) { c.company[f] = fields[f]; });
      ppWriteCache(c);
    }
  }

  function setupCompanyDataEdit() {
    if (!dataEditBtn || !dataForm) return;
    dataEditBtn.hidden = false;
    if (dataEditBtn.getAttribute('data-bound')) return; // no re-enganchar
    dataEditBtn.setAttribute('data-bound', '1');

    dataEditBtn.addEventListener('click', function () {
      dataEditBtn.disabled = true;
      // Re-cargar datos FRESCOS antes de abrir el form. Si el cache estaba viejo,
      // pre-cargar valores viejos borraba campos al guardar (manda todos los campos).
      fetch('/apps/crm/customer-company', { method: 'GET', credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          if (d && d.company) { renderCompanyData(d); ppWriteCache(d); }
        })
        .catch(function () { /* si el fetch falla, abrimos con lo que haya */ })
        .finally(function () {
          fillDataForm();
          if (dataView) dataView.hidden = true;
          dataForm.hidden = false;
          dataEditBtn.hidden = true;
          dataEditBtn.disabled = false;
          if (dataFeedback) dataFeedback.hidden = true;
          var first = dataForm.querySelector('input');
          if (first) first.focus();
        });
    });

    if (dataCancelBtn) dataCancelBtn.addEventListener('click', closeDataForm);

    dataForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var payload = {};
      COMPANY_FIELDS.forEach(function (f) {
        var input = dataForm.querySelector('[name="' + f + '"]');
        if (input) payload[f] = (input.value || '').trim();
      });
      var submitBtn = dataForm.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      if (dataFeedback) dataFeedback.hidden = true;

      post('update_company', { company: payload })
        .then(function (res) {
          if (res.d && res.d.ok) {
            COMPANY_FIELDS.forEach(function (f) { companyData[f] = payload[f]; setCF(f, payload[f]); });
            ppPatchCacheCompany(payload); // mantener el cache fresco → refresh OK
            closeDataForm();
            showDataFeedback(t('company-updated') || 'Datos actualizados.', false);
          } else {
            showDataFeedback(dataErr(res.d && res.d.code), true);
          }
        })
        .catch(function () { showDataFeedback(t('err-generic'), true); })
        .finally(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  }

  // ── Invitar ──

  function showFeedback(msg, isError) {
    if (!feedback) return;
    feedback.textContent = msg;
    feedback.classList.toggle('pp-empresa__feedback--error', !!isError);
    feedback.hidden = false;
  }

  function bindInvite() {
    if (!inviteToggle || !inviteForm) return;
    inviteToggle.addEventListener('click', function () {
      var open = inviteForm.hidden;
      inviteForm.hidden = !open;
      inviteToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = inviteForm.querySelector('input[name="first_name"]');
        if (first) first.focus();
      }
    });

    inviteForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var firstName = (inviteForm.querySelector('input[name="first_name"]').value || '').trim();
      var lastName = (inviteForm.querySelector('input[name="last_name"]').value || '').trim();
      var email = (inviteForm.querySelector('input[name="email"]').value || '').trim();
      if (!firstName || !email || email.indexOf('@') < 1) {
        showFeedback(t('err-invalid'), true);
        return;
      }
      var submitBtn = inviteForm.querySelector('button[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = t('invite-sending'); }
      if (feedback) feedback.hidden = true;

      post('invite', { first_name: firstName, last_name: lastName, email: email })
        .then(function (res) {
          var d = res.d;
          if (d && d.ok && d.member) {
            if (list) list.appendChild(memberRow(d.member));
            updateMembersChip(list ? list.children.length : 0);
            showFeedback(t('invite-sent').replace('{email}', email), false);
            inviteForm.reset();
            inviteForm.hidden = true;
            inviteToggle.setAttribute('aria-expanded', 'false');
            return;
          }
          var code = d && d.code;
          if (code === 'email_exists') showFeedback(t('err-email-exists'), true);
          else if (code === 'already_member') showFeedback(t('err-already-member'), true);
          else if (code === 'invalid_email') showFeedback(t('err-invalid'), true);
          else showFeedback(t('err-generic'), true);
        })
        .catch(function () { showFeedback(t('err-generic'), true); })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = t('invite-send'); }
        });
    });
  }

  // GET + render de la lista de miembros. Se usa al boot y para refrescar tras
  // activar/desactivar (la fila no se borra localmente; se re-pinta desde el
  // backend para reflejar revoked/rol reales).
  function reloadMembers() {
    fetch('/apps/crm/customer-members', { method: 'GET', credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(renderMembers)
      .catch(function () {});
  }

  function boot(companyData) {
    if (renderCompany(companyData)) {
      bindInvite();
      reloadMembers();
      loadActivity();
    }
  }

  // Cache aislado por cliente (misma key que pp-company.js): evita filtrar la
  // empresa de un usuario al siguiente si entran en la misma pestaña.
  // v2 (2026-07-17): bump por caches envenenados pre-router — ver pp-company.js.
  // v3 (2026-07-18): la respuesta de customer-company ahora trae los datos de
  // empresa (nombre comercial, teléfono, etc.); bump para no leer cache v2 sin ellos.
  var CACHE_KEY = ppCacheKey();
  var cached;
  try { cached = sessionStorage.getItem(CACHE_KEY); } catch (_) {}
  if (cached) {
    try { boot(JSON.parse(cached)); return; } catch (_) { /* cache corrupto → fetch */ }
  }

  if (window.Shopify && window.Shopify.designMode) { boot(null); return; }

  fetch('/apps/crm/customer-company', { method: 'GET', credentials: 'same-origin' })
    .then(function (r) { return r.json().catch(function () { return null; }); })
    .then(boot)
    .catch(function () { boot(null); });
})();
